import type { RouteRecordRaw } from "vue-router"
import { type StaticProviderKey } from "@versatile-credit-apply/omni-apply-client"
import {
  useApplicationStore,
  useCurrentApplyResponse,
} from "@versatile-credit-apply/sdk"

const providerKey: StaticProviderKey = "ads_standard"

export const AdsDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "ads-apply-pending",
    path: "pending",
    component: () => import("./components/AdsPending.vue"),
  },
  {
    name: "ads-apply-declined",
    path: "declined",
    component: () => import("./components/AdsDeclined.vue"),
  },
  {
    name: "ads-apply-account-found",
    path: "account-found",
    component: () => import("./components/AdsAccountFound.vue"),
  },
  {
    name: "ads-apply-approved",
    path: "approved",
    component: () => import("./components/AdsApproved.vue"),
  },
  {
    name: "ads-apply-prequalified",
    path: "prequalified",
    component: () => import("./components/AdsPrequalified.vue"),
    meta: {
      step: "applicant",
      next: "../terms",
    },
  },
  {
    name: "ads-apply-error",
    path: "error",
    component: () => import("./components/AdsError.vue"),
  },
  {
    name: "ads-apply-nooffer",
    path: "nooffer",
    component: () => import("./components/AdsNoOffer.vue"),
  },
]

export const AdsProveRoutes: RouteRecordRaw[] = [
  {
    name: "ads-prove-challenge",
    path: "challenge",
    component: () => import("./pages/AdsProveChallengePage.vue"),
  },
  {
    name: "ads-prove-instant-link",
    path: "instant-link",
    component: () => import("./pages/AdsProveInstantLinkPage.vue"),
  },
  {
    name: "ads-prove-verification-progress",
    path: "verifying",
    component: () => import("./pages/AdsProveVerificationProgressPage.vue"),
  },
  {
    name: "ads-prove-next",
    path: "next",
    redirect: () => "/apply/workflows/prove/next", // Since this is a Prove workflow, go to the next workflow
  },
]

export const AdsApplyRoutes: RouteRecordRaw[] = [
  {
    name: "ads-apply-routes",
    path: "ads_standard",
    children: [
      {
        name: "ads-apply-start",
        path: "start/:mode",
        component: () => import("./pages/AdsIntroPage.vue"),
        meta: {
          step: "applicant",
        },
      },
      {
        name: "ads-terms",
        path: "terms",
        component: () => import("./pages/AdsTermsAndConditionsPage.vue"),
        meta: {
          next: () => {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "accept-offer" : "submit"
          },
          step: "terms",
        },
      },
      {
        name: "ads-apply-decisions",
        path: "decision",
        component: () => import("./pages/AdsDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: AdsDecisionRoutes,
        beforeEnter: (to) => {
          if (to.name === "ads-apply-account-found") {
            return true
          }
          const response = useCurrentApplyResponse(providerKey)
          if (response.value?.existingAccount) {
            return { name: "ads-apply-account-found" }
          }
          return true
        },
      },
      {
        name: "ads-prove",
        path: "prove",
        children: AdsProveRoutes,
      },
    ],
  },
]
